import { Component } from '@angular/core';

@Component({
  selector: 'app-epson-powered',
  templateUrl: './epson-powered.component.html',
  styleUrls: ['./epson-powered.component.scss'],
})
/**
 * Powered By Epson!
 */
export class EpsonPoweredComponent {}
